import { RootState } from 'redux/store'

export const selectSelectedUserProfileMenuItem: (state: RootState) => string = (state) =>
  state.profile.menu.selectedItem

export const selectSelectedUserProfileSubMenu: (state: RootState) => string = (state) =>
  state.profile.menu.selectedSubMenu
